import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shippingStation' })
export class ShippingStationPipe implements PipeTransform {
    constructor() {
    }

    public transform(shippingStationId): string {
        if (!shippingStationId) {
            return '0';
        }

        switch (shippingStationId) {
            case 100001:
                return 'US';
            case 3:
                return 'SG';
            case 5:
                return 'DE';
            case 6:
                return 'GB';
            case 1:
                return 'TH';
            case 2:
                return 'HK';
            case 4:
                return 'JP';
            case 7:
                return 'CA';
            case 13:
                return 'CN';
            case 14:
                return 'TW';
            case 8:
                return 'US';
            case 9:
                return 'US';
            case 10:
                return 'US';
            case 11:
                return 'US';
            case 12:
                return 'US';
        }
    }
}
